import "UI/Widget/Forms/Control/Input";
NS("UI.Widget.Forms.Control");

UI.Widget.Forms.Control.Password = Class(UI.Widget.Forms.Control.Input, {
    createElement: function() {
        this.$element = $("<input type='password'>");
    }
});
